export default {
  invalidLoginWarningLimit: 4,
};
